import { ChevronLeft, ChevronRight } from "lucide-react";

/** MonthNav — picker bulan + tombol prev/next.
 * Props: value (YYYY-MM), onChange (str), testIdPrefix (opsional). */
export function MonthNav({ value, onChange, testIdPrefix = "cash-month", prevMonthLabel, shiftMonth }) {
  return (
    <div className="inline-flex items-stretch border border-zinc-300 bg-white">
      <button
        type="button"
        data-testid={`${testIdPrefix}-prev`}
        onClick={() => onChange(shiftMonth(value, -1))}
        title={`Bulan Sebelumnya (${prevMonthLabel(value)})`}
        className="px-2 border-r border-zinc-300 text-zinc-600 hover:bg-[#002FA7] hover:text-white transition-colors flex items-center"
      >
        <ChevronLeft className="w-4 h-4" />
      </button>
      <input
        type="month"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={`${testIdPrefix}-filter`}
        className="border-none bg-transparent px-3 py-2 text-sm font-mono focus:outline-none focus:bg-[#002FA7]/5"
      />
      <button
        type="button"
        data-testid={`${testIdPrefix}-next`}
        onClick={() => onChange(shiftMonth(value, 1))}
        title={`Bulan Berikutnya (${(() => { const nm = shiftMonth(value, 1); return prevMonthLabel(shiftMonth(nm, 1)); })()})`}
        className="px-2 border-l border-zinc-300 text-zinc-600 hover:bg-[#002FA7] hover:text-white transition-colors flex items-center"
      >
        <ChevronRight className="w-4 h-4" />
      </button>
    </div>
  );
}